import { connect } from 'react-redux'

import Form from './form'
import Confirmation from './confirmation'

const Cancellation = ({ cancelled }) => (
  cancelled ? <Confirmation /> : <Form />
)

const mapStateToProps = (state) => ({
  cancelled: state.invitee.cancelled
})

export default connect(mapStateToProps)(Cancellation)
